import { render, staticRenderFns } from "./UserActivityTable.vue?vue&type=template&id=44f0e9c2&scoped=true&"
import script from "./UserActivityTable.vue?vue&type=script&lang=js&"
export * from "./UserActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityTable.vue?vue&type=style&index=0&id=44f0e9c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0e9c2",
  null
  
)

export default component.exports